import type { ChatMessageStatus } from './type';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapToChatMessageStatus = (r: any): ChatMessageStatus => {
  return {
    unreadCount: r.unread_count,
    unansweredCount: r.unanswered_count
  };
};
